import { action, observable } from "mobx";
import { api, apiOperacao } from "../../api";
import { ITipi } from "../../model";
import { toast } from "react-toastify";
import { toast_error } from "../../utils";

export class _TipiStore {
  obs = observable({
    tipis: [] as ITipi[],
    total: 0 as number,
  })


  constructor() {
  }

  @action
  async load(page: number): Promise<void> {
    try {
      let resp = await apiOperacao("legislacoes").get(`/legislacoes/tipi-index/${page}`);

      this.obs.tipis = [];
      this.obs.total = resp.data.total;
      this.obs.tipis = resp.data.itens
    } catch (ex) {
      toast_error(ex, `Erro ao carregar Tipi, tente novamente mais tarde.`);
    }
  }

  async busca(filter: string, paged) {
    try {
      let params = {
        filter: filter,
        page: paged,
        limit: 15
      }
      let resp = await apiOperacao("legislacoes").post(`/legislacoes/filtra-tipi`, params);

      this.obs.tipis = [];
      this.obs.total = resp.data.total;
      this.obs.tipis = resp.data.itens
    } catch (ex) {
      toast_error(ex, `Erro ao filtrar Tipi, tente novamente mais tarde.`);
    }
  }
}

export const TipiStore = new _TipiStore();
